/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/prop-types */
// @ts-nocheck

import PropTypes from 'prop-types'
import React, { lazy, Suspense } from 'react'
import { BrowserRouter as Router, Redirect, Route, Switch } from 'react-router-dom'

import PendingInfo from './components/auth/register/PendingInfo'
import ProfileLocked from './components/auth/register/ProfileLocked'
import RejectedInfo from './components/auth/register/RejectedInfo'
import MaintenanceServiceStatus from './components/maintenance/Maintenance'
import AllProgramsOpen from './containers/sis/student/AllProgramsOpen'
import CourseCompletedContainer from './containers/sis/student/courseCompletedContainer'
import CustomSurvey from './containers/sis/student/CustomSurvey'
import PaymentSuccessGuestCheckoutContainer from './containers/sis/student/PaymentSuccessGuestCheckout'
import ProgramDetailsOpen from './containers/sis/student/ProgramDetailsOpen'
import ProgramsCompletedContainer from './containers/sis/student/ProgramsCompletedContainer'
import SchoolStoreContainer from './containers/sis/student/SchoolStore'
import Submissions from './containers/sis/student/Submissions'

const LoginContainer = lazy(() => import('./containers/auth/Login'))
const ForgotPasswordContainer = lazy(() => import('./containers/auth/ForgotPassword'))
const PasswordResetContainer = lazy(() => import('./containers/auth/PasswordReset'))
const SignUpContainer = lazy(() => import('./containers/auth/SignUp'))
const SIS = lazy(() => import('./containers/sis/SIS'))
const PageNotFound = lazy(() => import('./containers/sis/PageNotFound'))

const Routes = ({ metadata }) => {
  return (
    <Router>
      <Suspense fallback={null}>
        <MaintenanceServiceStatus metadata={metadata}>
          <Switch>
            <Redirect exact from="/:district/:school" to="/:district/:school/login" />
            <Route exact path="/">
              <LoginContainer />
            </Route>
            <Route path="/:district/:school/login/:source?">
              <LoginContainer />
            </Route>
            <Route path="/:district/:school/allprograms">
              <AllProgramsOpen />
            </Route>
            <Route path="/:district/:school/surveys/:id">
              <CustomSurvey />
            </Route>
            <Route path="/:district/:school/programreviews">
              <ProgramsCompletedContainer />
            </Route>
            <Route path="/:district/:school/coursereviews">
              <CourseCompletedContainer />
            </Route>
            <Route path="/:district/:school/programdetailsopen/:progId">
              <ProgramDetailsOpen />
            </Route>
            <Route path="/:district/:school/forgotpassword">
              <ForgotPasswordContainer />
            </Route>
            <Route path="/:district/:school/passwordreset">
              <PasswordResetContainer />
            </Route>
            <Route path="/:district/:school/register">
              <SignUpContainer />
            </Route>
            <Route path="/:district/:school/schoolstore">
              <SchoolStoreContainer />
            </Route>
            <Route path="/:district/:school/guestcheckoutsuccess">
              <PaymentSuccessGuestCheckoutContainer />
            </Route>
            <Route path="/:district/:school/status/pending">
              <PendingInfo />
            </Route>
            <Route path="/:district/:school/status/rejected">
              <RejectedInfo />
            </Route>
            <Route path="/:district/:school/locked">
              <ProfileLocked />
            </Route>
            <Route path="/:district/:school/sis">
              <SIS />
            </Route>
            <Route exact path={`/submissions/:tenant?/:id?`}>
              <Submissions />
            </Route>
            <Route path="/notfound">
              <PageNotFound />
            </Route>
            <Route>
              <PageNotFound />
            </Route>
          </Switch>
        </MaintenanceServiceStatus>
      </Suspense>
    </Router>
  )
}

Routes.propTypes = {
  metadata: PropTypes.object,
}

export default Routes
